import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  ejemplo: {
    data: [],
  }
}

// Ejemplo de uso:
const mantenerListadosSlice = createSlice({
  name: 'mantenerListados',
  initialState,
  reducers: {
    setSectionData: (state, action) => {
      const { section, data } = action.payload
      state[section].data = data
    },
    reset: () => initialState,
  },
})

export const { setSectionData, reset } =
  mantenerListadosSlice.actions
export default mantenerListadosSlice.reducer
